import React from 'react';
import { styles } from './updatePriorityList.style';

const PriorityTags = ({ priorities }: { priorities: string[] }) => (
	<div className='tag-container'>
		{priorities.map((priority) => (
			<div key={priority} style={styles.tag}>
				{priority}
			</div>
		))}
	</div>
);

export default PriorityTags;
